import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/login',
            meta: {
                layout: "login-layout",
                guest: true
            },
            component: () => import('./views/Login.vue'),
        },
        {
            path: '/login/:site/:foroomLogin/:foroomPassword',
            props: true,
            meta: {
                layout: "login-layout",
                guest: true
            },
            component: () => import('./views/Login.vue'),
        },
        {
            path: '/forgot',
            meta: {
                layout: "login-layout",
                guest: true
            },
            component: () => import('./views/ForgotPassword.vue')
        },
        {
            path: '/forgot/:secret',
            props: true,
            meta: {
                layout: "login-layout",
                guest: true
            },
            component: () => import('./views/ForgotPassword.vue')
        },
        {
            path: '/news/:id',
            component: () => import('./views/News'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/ordersState',
            component: () => import('./views/OrdersState.vue'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        // {
        //     path: '/order',
        //     component: () => import('./views/Order'),
        //     // component: () => import('./views/Test'),
        //     props: true,
        //     meta: {
        //         layout: "main-layout",
        //         requiresAuth: true
        //     }
        // },
        {
            path: '/order/:orderId',
            component: () => import('./views/Order'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/reorder/:orderId',
            component: () => import('./views/Reorder'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/accessoriesOrdering',
            component: () => import('./views/AccessoriesOrdering'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/accessoriesOrdering/:new',
            component: () => import('./views/AccessoriesOrdering'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/configurator',
            component: () => import('./views/Configurator'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/configurator/:id',
            component: () => import('./views/Configurator'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/itemsList/:setId/:groupId',
            component: () => import('./views/ItemsList'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/orderFromCatalog',
            component: () => import('./views/OrderFromCatalog'),
            // component: () => import('./views/OrderFromCatalog_b'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/orderFromCatalogPartner',
            component: () => import('./views/OrderFromCatalogPartner'),
            // component: () => import('./views/OrderFromCatalog_b'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/basket',
            component: () => import('./views/Basket'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/readyMade',
            component: () => import('./views/ReadyMade'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/readyMade/:orderId',
            component: () => import('./views/ReadyMade'),
            props: true,
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/actions',
            component: () => import('./views/Actions'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures',
            component: () => import('./views/AdditionalFeatures'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/paymentsSchedule',
            component: () => import('./views/PaymentsSchedule'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/payers',
            component: () => import('./views/Payers'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/POA',
            component: () => import('./views/POA_new'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/deliveries',
            component: () => import('./views/Deliveries'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/balance',
            component: () => import('./views/Balance'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/addNewUser',
            component: () => import('./views/AddNewUser'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/manageUsers',
            component: () => import('./views/ManageUsers'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/parameters',
            component: () => import('./views/Parameters'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/textures',
            component: () => import('./views/Textures'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/priceLists',
            component: () => import('./views/PriceLists'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/presentations',
            component: () => import('./views/Presentations'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/videos',
            component: () => import('./views/Videos'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/manuals',
            component: () => import('./views/Manuals'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/additionalFeatures/pushSubscribe',
            component: () => import('./views/PushSubscribe'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/waitList',
            component: () => import('./views/WaitList'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/agreement',
            component: () => import('./views/Agreement'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/translation',
            component: () => import('./views/Translation'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        },
        {
            path: '/mknewlogin/:inviteKey',
            component: () => import('./views/Mknewlogin'),
            props: true,
            meta: {
                layout: "login-layout",
                requiresAuth: false
            }
        },
        {
            path: "*",
            component: () => import('./views/PageNotFound'),
            meta: {
                layout: "main-layout",
                requiresAuth: true
            }
        }
    ]
})
